var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "form" } },
    [
      _c(
        "app-modal",
        {
          attrs: {
            closeOutside: false,
            titulo: "Atenção",
            width: 800,
            height: 220,
            hasButtonX: false
          },
          on: {
            closeModal: function($event) {
              return _vm.closeModal()
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              [
                _c(
                  "el-row",
                  { staticClass: "message" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.notificacao.mensagem))]),
                    _c("el-col", {
                      staticClass: "margin-top",
                      attrs: { lg: 34, md: 34, sm: 34 }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "buttons" },
              [
                _c(
                  "el-button",
                  {
                    key: "botao-confirma",
                    staticClass: "botaoOk",
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.ok()
                      }
                    }
                  },
                  [_vm._v(" Marcar como lido")]
                )
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84f631ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84f631ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/components/AppModalNotificacao.vue
// module id = null
// module chunks = 